import React, { Component } from 'react';
import { connect } from 'react-redux';
import {formatPhoneNumber} from '../../../underwriter/helpers';
class ContactInfo extends Component {
    render() {
        const underwriter = this.props.underwriter;
        const mailhref = "mailto:" + underwriter.email;
        const defaultUW = !!this.props.contactUnderWriter &&
            this.props.contactUnderWriter.find(uw=> uw.defaultUnderWriter === true || uw.defaultUnderWriter === 'true')
        const mail = "mailto:"+defaultUW.email;
        const defaultUnderwriterDisplay=(
            <div className="col-lg-12 col-md-8 col-sm-8 col-xs-12">
                    For immediate questions or issues, please 
                    contact {defaultUW.firstName} {defaultUW.lastName}{' '}
                    <a href={mail}>
                    {defaultUW.email}
                    </a>{' '}
                    <br></br>
                    + {defaultUW.phoneExt} {defaultUW.phone}.
                </div>
        );
        let underwriterDisplay=defaultUnderwriterDisplay;
        if(!underwriter.isLoggedUser){
            underwriterDisplay=(
                <div className="col-lg-12 col-md-8 col-sm-8 col-xs-12">
                    For immediate questions or issues, please 
                    contact {underwriter.name}{' '}
                    <a href={mailhref}>
                        {underwriter.email}
                    </a>{' '}
                    <br></br>
                    {underwriter.phoneExt}{' '}{formatPhoneNumber(underwriter.phone)}.
                </div>
            );
        } 
        return (
            <div className="row">
                {underwriterDisplay}
            </div>
        );
    }
}


const mapStateToProps = state => ({
    underwriter: state.underwriter,
    contactUnderWriter: state.auth.contactUnderWriter
  })


export default connect(mapStateToProps)(ContactInfo)